module.exports = __webpack_public_path__ + "img/Noctiluca-Process-4.f4891a30.png";